import React from 'react';

export const StepCount = ({step}) => (
	<p className="visitation-step">
		Step&nbsp;{step}/10
	</p>
);


// WEBPACK FOOTER //
// ./src/components/StepCount/StepCount.js